import "core-js/modules/es.array.concat";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classnames from 'classnames';
import classes from './Badge.scss';
/* TODO: remove these checks, because they are set globally */

/* eslint-disable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

function Badge(_ref) {
  var _classnames;

  var position = _ref.position,
      value = _ref.value,
      children = _ref.children,
      overlap = _ref.overlap,
      color = _ref.color,
      className = _ref.className,
      max = _ref.max,
      showZero = _ref.showZero,
      isInvisible = _ref.isInvisible,
      isDot = _ref.isDot;
  var hasValue = typeof value === 'number';
  var invisible = isInvisible;

  if (!invisible && (!hasValue && !isDot || hasValue && value === 0 && !showZero)) {
    invisible = true;
  }

  var counterValue = '';

  if (!isDot && typeof value === 'number') {
    counterValue = max > 0 && value > max ? "".concat(max, "+") : value;
  }

  return /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.root, className)
  }, children, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.badge, classes["position-".concat(position.vertical, "-").concat(position.horizontal, "-").concat(overlap)], [classes["color-".concat(color)]], (_classnames = {}, _defineProperty(_classnames, classes.invisible, invisible), _defineProperty(_classnames, classes.dot, isDot), _classnames))
  }, counterValue));
}

Badge.defaultProps = {
  position: {
    vertical: 'top',
    horizontal: 'right'
  },
  value: undefined,
  overlap: 'rectangle',
  color: 'accent',
  className: '',
  max: 0,
  showZero: true,
  isInvisible: false,
  isDot: false
};
export default Badge;